// App-wide GSAP + Lenis setup. Imported once, first, from index.js, so
// plugins are registered and Lenis exists before any component runs.
// Lenis + ScrollTrigger wiring is the standard recipe from the Lenis docs.
// Touch devices keep native scroll (Lenis' default syncTouch: false).
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger, useGSAP);

// Feel knob: `lerp` (default 0.1, lower = smoother/slower)
export const lenis = new Lenis();

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => lenis.raf(time * 1000));
gsap.ticker.lagSmoothing(0);

export const scrollToTarget = (selector) => lenis.scrollTo(selector);

// Jump to top on a route change. Through Lenis too, or a scroll still in
// flight would carry on toward its old target.
export const resetScroll = () => {
  lenis.scrollTo(0, { immediate: true, force: true });
  window.scrollTo(0, 0);
};
